import { useMemo } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { BaseListView, SectionCard } from "@/base";
import {
  bondHistoryListView,
  SFAA_FOOTNOTE,
} from "@/pages/bondHistoryListView";

// BRK-S406 — the Surety account's Bond history: the insured's bond
// submissions, with the bonds issued from each, on the shared list view
// (BRK-S255), embedded in the account's panel well. Each row opens its
// submission; the executed bond form downloads from the row.
//
// BRK-S501 — ONE component on two tabs: the wireframe ends Company profile
// with this table and draws it alone on Bond history. Both mounts read the
// same `bh*` URL keys, so a filter set on one is the filter on the other.
export function BondHistoryPanel({ accountId }: { accountId: string }) {
  const { authedRequest, authedBlob } = useAuth();
  const def = useMemo(
    () =>
      bondHistoryListView({
        request: authedRequest,
        fetchBlob: authedBlob,
        accountId,
      }),
    [authedRequest, authedBlob, accountId],
  );
  return (
    <SectionCard title="Bond history">
      <BaseListView def={def} embedded />
      <p className="mt-2 text-xs text-brk-dim">{SFAA_FOOTNOTE}</p>
    </SectionCard>
  );
}
